module.exports = __webpack_public_path__ + "img/closeModal.54f059e5.svg";